module.exports = __webpack_public_path__ + "static/media/separate-shower-bath.311e35b6.svg";